import { ActionPermissionsActionsNames } from './actionPermissions.actions';
import { ActionPermissionsState, ActionPermissionsAction } from './type';

const initialState: ActionPermissionsState = {
  isLoading: false,
  error: null,
  actionPermissions: [],
};

const actionPermissionsReducer = (
  state: ActionPermissionsState = initialState,
  action: ActionPermissionsAction
): ActionPermissionsState => {
  switch (action.type) {
    case ActionPermissionsActionsNames.GET_ACTION_PERMISSIONS.START:
      return {
        ...state,
        error: null,
        isLoading: true,
        actionPermissions: [],
      };
    case ActionPermissionsActionsNames.GET_ACTION_PERMISSIONS.FULFILLED:
      return {
        ...state,
        isLoading: false,
        actionPermissions: action.payload ?? [],
      };
    case ActionPermissionsActionsNames.GET_ACTION_PERMISSIONS.REJECTED:
    case ActionPermissionsActionsNames.UPDATE_ACTION_PERMISSION.REJECTED:
    case ActionPermissionsActionsNames.ADD_CUSTOMER_FULL_ACTION_PERMISSION.REJECTED:
      return {
        ...state,
        isLoading: false,
        error: action.payload ?? null,
      };
    case ActionPermissionsActionsNames.UPDATE_ACTION_PERMISSION.START:
    case ActionPermissionsActionsNames.ADD_CUSTOMER_FULL_ACTION_PERMISSION.START:
      return { ...state, isLoading: true, error: null };
    case ActionPermissionsActionsNames.UPDATE_ACTION_PERMISSION.FULFILLED:
    case ActionPermissionsActionsNames.ADD_CUSTOMER_FULL_ACTION_PERMISSION.FULFILLED:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

export default actionPermissionsReducer;
